module.exports = __webpack_public_path__ + "img/hyal-1@2x.d91bada8.png";